import focus from './focus';


const directives = {
  focus
}

//
export default {
  install(Vue) {
    Object.keys(directives).forEach(item => {
      Vue.directive(item, directives[item])
    })
  }
}
